
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { Task } from '@/types/task';

export const useReactivateTaskMutation = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (task: Task) => {
      const { data, error } = await supabase
        .from('tasks')
        .update({
          is_completed: false
        })
        .eq('id', task.id)
        .select('id, is_completed')
        .single();

      if (error) throw error;
      if (!data) {
        throw new Error('Failed to reactivate task - permission denied or task not found');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
      toast({
        title: "Task Reactivated",
        description: "The task has been reactivated and is back in your to-do list.",
      });
    },
    onError: (error) => {
      console.error('Error reactivating task:', error);
      toast({
        title: "Error",
        description: "Failed to reactivate task. Please try again.",
        variant: "destructive",
      });
    }
  });
};
